import { TeamOutlined } from '@ant-design/icons'
import { Input, Space } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import {
	ListPageIntro,
	ListPageShell,
	ListPageTotal,
	PagedResourceList,
} from '../../common'
import { UserListAction } from '../../common/UserListAction/UserListAction'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { onGetUsers } from '../../redux/user/user.action'
import { DEFAULT_PAGE_SIZE } from '../../utils/constant'
import { formatDayMonthYear } from '../../utils/function.utils'

const columns = [
	{
		title: 'User ID',
		dataIndex: 'id',
		key: 'id',
		width: 96,
	},
	{
		title: 'Auth Email',
		dataIndex: 'authEmail',
		key: 'authEmail',
	},
	{
		title: 'Auth Name',
		dataIndex: 'authName',
		key: 'authName',
	},
	{
		title: 'Word added',
		dataIndex: 'wordCount',
		key: 'wordCount',
	},
	{
		title: 'Created At',
		dataIndex: 'createdAt',
		key: 'createdAt',
		render: value => formatDayMonthYear(value),
	},
	{
		title: 'Created By',
		dataIndex: 'createdBy',
		key: 'createdBy',
	},
	{
		title: 'Action',
		dataIndex: 'action',
		key: 'action',
		align: 'center',
		width: 100,
		// eslint-disable-next-line react/display-name
		render: (_, record) => <UserListAction user={record} />,
	},
]

export const UserList = () => {
	const dispatch = useAppDispatch()
	const user = useAppSelector(state => state.user)
	const [emailInput, setEmailInput] = useState('')
	const [authEmail, setAuthEmail] = useState('')
	const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)

	const fetchPage = useCallback(
		(page = 0, second) => {
			// PagedResourceList may pass pageSize (number) or a callback.
			let size = pageSize
			let callback
			if (typeof second === 'function') {
				callback = second
			} else if (typeof second === 'number') {
				size = second
			}
			return dispatch(
				onGetUsers(page, size, { authEmail }, callback)
			)
		},
		[dispatch, authEmail, pageSize]
	)

	useEffect(() => {
		dispatch(onGetUsers(0, pageSize, { authEmail }))
	}, [dispatch, pageSize, authEmail])

	const handleSearchEmail = value => {
		const next = (value || '').trim()
		setEmailInput(next)
		setAuthEmail(next)
	}

	const topLeft = (
		<ListPageIntro
			icon={TeamOutlined}
			title="Users"
			subtitle="Registered users and word counts. Filter by email prefix."
		/>
	)

	const topRight = (
		<Space wrap align="center">
			<Input.Search
				allowClear
				placeholder="Filter by email"
				value={emailInput}
				onChange={e => setEmailInput(e.target.value)}
				onSearch={handleSearchEmail}
				style={{ width: 280 }}
			/>
			<ListPageTotal total={user?.total} />
		</Space>
	)

	return (
		<ListPageShell>
			<PagedResourceList
				resource={user}
				columns={columns}
				fetchPage={fetchPage}
				rowKey={record => record.id ?? record.authEmail}
				headerClassName="list-page-bar"
				topLeft={topLeft}
				topRight={topRight}
				pageSize={pageSize}
				onPageSizeChange={setPageSize}
				fetchOnMount={false}
				tableProps={{ className: 'table-common--fluid' }}
			/>
		</ListPageShell>
	)
}
